import { useEffect } from "react";

// Kaydedilmemiş taslak varken sayfadan ayrılma uyarısı: tarayıcı kapat/yenile (beforeunload) + uygulama içi link tıklamaları
export default function useUnsavedWarning(dirty, message = "Kaydetmediğiniz puantaj/görevlendirme verileri var. Sayfadan ayrılırsanız kaybolacak. Yine de çıkılsın mı?") {
  useEffect(() => {
    if (!dirty) return;
    const onBefore = (e) => { e.preventDefault(); e.returnValue = message; return message; };
    const onClick = (e) => {
      const a = e.target.closest?.("a[href]");
      if (!a || a.target === "_blank" || a.hasAttribute("download") || a.dataset.allowLeave) return;
      const href = a.getAttribute("href") || "";
      if (!href.startsWith("/") || href.startsWith(window.location.pathname + window.location.search)) return;
      if (!window.confirm(message)) { e.preventDefault(); e.stopPropagation(); }
    };
    window.addEventListener("beforeunload", onBefore);
    document.addEventListener("click", onClick, true);
    return () => { window.removeEventListener("beforeunload", onBefore); document.removeEventListener("click", onClick, true); };
  }, [dirty, message]);
}
